// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-tenyzaraina {
  width: 350px;
  background: #fff;
  border-radius: 10px;
  padding: 0 20px;
  margin: 20px;
  position: relative;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
.card-tenyzaraina .entete {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
}
.card-tenyzaraina .entete .logo-entete {
  display: flex;
  flex-direction: row;
}
.card-tenyzaraina .entete .logo-entete img {
  height: 55px;
  width: 55px;
  margin: 15px 15px 15px 0;
  border: 1px solid #efefef;
  border-radius: 50px;
}
.card-tenyzaraina .entete .logo-entete .date {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.card-tenyzaraina .entete .logo-entete .date .title,
.card-tenyzaraina .entete .logo-entete .date .date-publication {
  display: flex;
  margin: 0;
}
.card-tenyzaraina .entete .logo-entete .date .title {
  font-size: 18px;
  color: #050505;
  font-weight: 600;
}
.card-tenyzaraina .entete .logo-entete .date .date-publication {
  color: #65676b;
  font-size: 15px;
}
.card-tenyzaraina .entete .menu {
  position: absolute;
  top: 15%;
  left: 96%;
  display: flex;
}
.card-tenyzaraina .entete .menu .menu-options {
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  z-index: 999;
  transition: transform 0.3s ease;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: bold;
}
.card-tenyzaraina .entete .menu .menu-options a, .card-tenyzaraina .entete .menu .menu-options span {
  text-decoration: none;
  color: #050505;
  padding: 2px;
}
.card-tenyzaraina .entete .menu .menu-options a:hover, .card-tenyzaraina .entete .menu .menu-options span:hover {
  color: #282881;
}
.card-tenyzaraina .teny {
  max-height: 100%;
  overflow: auto;
}
.card-tenyzaraina .teny p {
  font-size: 17px;
  position: relative;
  line-height: 1.4;
  white-space: break-spaces;
}
.card-tenyzaraina .teny img, .card-tenyzaraina .teny video {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 40vh;
  border-radius: 5px;
  display: block;
}
.card-tenyzaraina .teny .voir {
  font-size: 15px;
  color: #333;
  cursor: pointer;
}
.card-tenyzaraina .teny .voir:hover {
  color: #282881;
  cursor: pointer;
}
.card-tenyzaraina .teny .audio-container {
  display: flex;
  flex-direction: column;
  margin: 10px auto;
}
.card-tenyzaraina .theme-teny p {
  font-size: 16px;
  font-weight: 550;
}`, "",{"version":3,"sources":["webpack://./src/components/Card/CardTenyzaraina/cardteny.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EAGA,uCAAA;AADF;AAGE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AADJ;AAGI;EACE,aAAA;EACA,mBAAA;AADN;AAEM;EACE,YAAA;EACA,WAAA;EACA,wBAAA;EACA,yBAAA;EACA,mBAAA;AAAR;AAGM;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AADR;AAGM;;EAEI,aAAA;EACA,SAAA;AADV;AAIQ;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAFV;AAKQ;EACE,cAAA;EACA,eAAA;AAHV;AAQI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;AANN;AAQM;EACE,gBAAA;EACA,uCAAA;EACA,kBAAA;EACA,YAAA;EACA,+BAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AANR;AAQQ;EACE,qBAAA;EACA,cAAA;EACA,YAAA;AANV;AAQQ;EACE,cAAA;AANV;AAYE;EACE,gBAAA;EACA,cAAA;AAVJ;AAYI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AAVN;AAaI;EACE,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AAXN;AAcI;EACE,eAAA;EACA,WAAA;EACA,eAAA;AAZN;AAcI;EACE,cAAA;EACA,eAAA;AAZN;AAgBI;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AAdN;AAmBI;EACE,eAAA;EACA,gBAAA;AAjBN","sourcesContent":[".card-tenyzaraina {\n  width: 350px;\n  background: #fff;\n  border-radius: 10px;\n  padding: 0 20px;\n  margin: 20px;\n  position: relative;\n  // max-height: 550px;\n  // overflow-y: auto;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n\n  .entete {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    position: relative;\n\n    .logo-entete{\n      display: flex;\n      flex-direction: row;\n      img {\n        height: 55px;\n        width: 55px;\n        margin: 15px 15px 15px 0;\n        border: 1px solid #efefef;\n        border-radius: 50px;\n      }\n  \n      .date {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n  \n      .title,\n        .date-publication {\n          display: flex;\n          margin: 0;\n        }\n\n        .title {\n          font-size: 18px;\n          color: #050505;\n          font-weight: 600;\n        }\n\n        .date-publication {\n          color: #65676b;\n          font-size: 15px;\n        }\n      }\n    }\n\n    .menu{\n      position: absolute;\n      top: 15%;\n      left: 96%;\n      display: flex;\n\n      .menu-options{\n        background: #fff;\n        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n        border-radius: 5px;\n        z-index: 999;\n        transition: transform 0.3s ease;\n        padding: 10px;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        font-weight: bold;\n\n        a,span{\n          text-decoration: none;\n          color: #050505;\n          padding: 2px;\n        }\n        a:hover, span:hover{\n          color: #282881;\n        }\n      }\n    }\n  }\n\n  .teny {\n    max-height: 100%; \n    overflow: auto;\n\n    p {\n      font-size: 17px;\n      position: relative;\n      line-height: 1.4;\n      white-space: break-spaces;\n    }\n\n    img,video {\n      margin: 0;\n      padding: 0;\n      width: 100%; \n      height: 40vh;\n      border-radius: 5px;\n      display: block;\n    }\n\n    .voir{\n      font-size:15px;\n      color: #333;\n      cursor: pointer;\n    }\n    .voir:hover {\n      color: #282881; \n      cursor: pointer;\n\n    }\n\n    .audio-container{\n      display: flex;\n      flex-direction: column;\n      margin: 10px auto;\n    }\n  }\n\n  .theme-teny {\n    p{\n      font-size: 16px;\n      font-weight: 550;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
